import { setActiveCommunityId } from 'community/state/communitySlice';

import { communityApi } from './communityApi';
import { selectHasNoCommunity } from './selectors';
import { RegisteredToCommunityActionPayload } from './types';

import type { Effect } from 'store';

export const registerToCommunitySuccessEffect: Effect = ({ payload }, { dispatch }) => {
  const { communityId } = payload as RegisteredToCommunityActionPayload;
  if (!communityId) return;

  dispatch(communityApi.util.invalidateTags(['MY_COMMUNITIES']));
  dispatch(setActiveCommunityId(communityId));
};

export const invalidateMyCommunitiesEffect: Effect = (_, { dispatch, getState }) => {
  const state = getState();

  const hasNoCommunity = selectHasNoCommunity(state);
  if (hasNoCommunity) {
    dispatch(communityApi.util.invalidateTags(['MY_COMMUNITIES']));
  }
};
